import { render, staticRenderFns } from "./IlmoittautuminenHallitus.vue?vue&type=template&id=21187d6c&scoped=true"
import script from "./IlmoittautuminenHallitus.vue?vue&type=script&lang=js"
export * from "./IlmoittautuminenHallitus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21187d6c",
  null
  
)

export default component.exports